import { showDate, showTime } from '.';
const columnCommonCofig = { sortable: false, width: 100 };

export const userTableColumns = [
  { field: 'name', headerName: 'Name', ...columnCommonCofig, minWidth: 200, flex: 1 },
  { field: 'email', headerName: 'Email', ...columnCommonCofig, minWidth: 250, flex: 1 },
  { field: 'status', headerName: 'Status', ...columnCommonCofig, flex: 1 },
  {
    field: 'role',
    headerName: 'Role',
    ...columnCommonCofig,
    flex: 1,
  },
];
export const employeeTableColumns = [
  {
    field: 'name',
    headerName: 'Name',
    ...columnCommonCofig,
    sortable: true,
    renderCell: ({ row }) => (row.name ? row.name : '-'),
    minWidth: 120,
  },
  {
    field: 'workDays',
    headerName: 'Work Days',
    ...columnCommonCofig,
    renderCell: ({ row }) => {
      return row.workDays && row.workDays.length > 0 ? row.workDays.join(', ') : '-';
    },
    minWidth: 140,
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone No.',
    ...columnCommonCofig,
    renderCell: ({ row }) => (row.phoneNumber ? row.phoneNumber : '-'),
    minWidth: 140,
  },
  {
    field: 'based',
    headerName: 'Based City',
    ...columnCommonCofig,
    renderCell: ({ row }) => (row.based ? row.based : '-'),
    minWidth: 120,
  },
  {
    field: 'jobCount',
    headerName: 'Job Count',
    ...columnCommonCofig,
    renderCell: ({ row }) => (row.jobCount ? row.jobCount : '-'),
  },
  {
    field: 'vanSize',
    headerName: 'Van Size',
    ...columnCommonCofig,
    renderCell: ({ row }) => (row.vanSize ? row.vanSize : '-'),
    minWidth: 100,
  },
  {
    field: 'vanReg',
    headerName: 'Van Reg',
    ...columnCommonCofig,
    renderCell: ({ row }) => {
      return row.restDays && row.restDays.length > 0 ? row.restDays.join(', ') : '-';
    },
    width: 140,
  },
  {
    field: 'vanMake',
    headerName: 'Van Make',
    ...columnCommonCofig,
    renderCell: ({ row }) => (row.vanMake ? row.vanMake : '-'),
  },
  {
    field: 'vanModel',
    headerName: 'Van Model',
    ...columnCommonCofig,
    renderCell: ({ row }) => (row.vanModel ? row.vanModel : '-'),
  },
  {
    field: 'vanColor',
    headerName: 'Van Color',
    ...columnCommonCofig,
    renderCell: ({ row }) => (row.vanColor ? row.vanColor : '-'),
  },
  {
    field: 'insuranceExpires',
    headerName: 'Ins. Expires',
    ...columnCommonCofig,
    sortable: true,
    renderCell: ({ row }) => (row.insuranceExpires ? showDate(row.insuranceExpires) : '-'),
    minWidth: 120,
  },
  {
    field: 'completedJobCount',
    headerName: 'Completion Rate',
    ...columnCommonCofig,
    renderCell: ({ row }) => (row.jobCount ? (row.completedJobCount * 100) / row.jobCount : '-'),
  },
  {
    field: 'rating',
    headerName: 'Rating',
    ...columnCommonCofig,
    renderCell: ({ row }) => (row.rating ? row.rating : '-'),
    minWidth: 110,
  },
  { field: 'status', headerName: 'Status', ...columnCommonCofig },
];

export const bookingTableColumns = [
  {
    field: 'dateTime',
    headerName: 'Start date',
    ...columnCommonCofig,
    width: 110,
    renderCell: ({ row }) => showDate(row.dateTime),
    sortable: true,
  },
  {
    field: 'time',
    headerName: 'Start time',
    ...columnCommonCofig,
    renderCell: ({ row }) => showTime(row.dateTime),
  },
  {
    field: 'firstName',
    headerName: 'Name',
    ...columnCommonCofig,
    renderCell: ({ row }) => row.firstName + ' ' + row.lastName,
    sortable: true,
    width: 180,
  },
  { field: 'phoneNumber', headerName: 'Phone', ...columnCommonCofig, width: 150 },
  { field: 'peopleInVan', headerName: 'People In Van', ...columnCommonCofig, width: 140 },
  {
    field: 'price',
    headerName: 'Price',
    ...columnCommonCofig,
    sortable: true,
    renderCell: ({ row }) => row.price.toFixed(2),
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    ...columnCommonCofig,
    width: 110,
    sortable: true,
    renderCell: ({ row }) => showDate(row.createdAt),
  },
  {
    field: 'createdAt Time',
    headerName: 'Created time',
    ...columnCommonCofig,
    renderCell: ({ row }) => showTime(row.createdAt),
    width: 140,
  },
  {
    field: 'status',
    headerName: 'Status',
    ...columnCommonCofig,
    renderCell: ({ row }) => row.status,
    width: 140,
  },
  {
    field: 'userId',
    headerName: 'Driver',
    ...columnCommonCofig,
    renderCell: ({ row }) => (row.userId ? row.userId.name : '-'),
    width: 180,
  },
];
export const bookingDriverTableColumns = (percentage) => [
  {
    field: 'startDate',
    headerName: 'Start Date',
    ...columnCommonCofig,
    minWidth: 150,

    renderCell: ({ row }) => showDate(row.dateTime),
  },
  {
    field: 'startTime',
    headerName: 'Start Time',
    ...columnCommonCofig,

    renderCell: ({ row }) => showTime(row.dateTime),
  },
  {
    field: 'name',
    headerName: 'Name',
    ...columnCommonCofig,
    minWidth: 200,
    renderCell: ({ row }) => row.firstName + ' ' + row.lastName,
  },
  { field: 'peopleInVan', headerName: 'People In Van', ...columnCommonCofig, minWidth: 110 },
  { field: 'loaderInVan', headerName: 'Loader In Van', ...columnCommonCofig, minWidth: 110 },
  {
    field: 'price',
    headerName: 'Price',
    ...columnCommonCofig,
    minWidth: 50,
    renderCell: ({ row }) => ((row.price / 100) * percentage).toFixed(2),
  },
  {
    field: 'createdDate',
    headerName: 'Created Date',
    ...columnCommonCofig,
    minWidth: 150,

    renderCell: ({ row }) => showDate(row.createdAt),
  },
  {
    field: 'createdTime',
    headerName: 'Created Time',
    ...columnCommonCofig,
    minWidth: 150,

    renderCell: ({ row }) => showTime(row.createdAt),
  },
  {
    field: 'status',
    headerName: 'Status',
    ...columnCommonCofig,
  },
];
